/**
 * `@/llm/guidedRuntime` reaches CognitoService for its token, which since SEC-14 stores the
 * refresh token in expo-secure-store and therefore pulls React Native into anything that
 * imports it — including, transitively, `@/llm/planLayouts` and `@/onboarding/
 * pickStyleFromPicture`, both of which the wizard wants for their PURE halves.
 *
 * So the runtime is replaced rather than the modules avoided: `parsePlan` and
 * `pickStyleFromPicture` come through intact, and the browser injects its own `generate`
 * (src/api/llm.ts), which goes to the same /llm proxy through the one typed request().
 *
 * This throws rather than returning a dummy client. A silent no-op here would look like a
 * model that answered with nothing, and the caller would report "that picture did not give
 * a clear look" for what is actually a wiring mistake.
 */
const MESSAGE =
  'The browser has no guided() client — pass `generate` from src/api/llm.ts instead.';

export function guided(): never {
  throw new Error(MESSAGE);
}

export function resetGuided(): void {
  /* nothing is cached, because nothing is ever created */
}
